module.exports = __webpack_public_path__ + "static/media/forshagavapen.7a43d1ab.png";